import ApiConstants from "../../Constants/ApiConstant";
import { apiDelete, apiGet, apiPost, apiPut } from "../../Services/ApiService";

  export const getProductPurityDetailsAPI = (params, callBack) => {
    return async () => {
      try {
        let url = ApiConstants.productMetalPurityUrl;
        const queryParams = [];
  
        if (params?.searchQuery)
          queryParams.push(`search=${encodeURIComponent(params.searchQuery)}`);
        if (params.page)
          queryParams.push(`page=${encodeURIComponent(params.page)}`);
        if (params.limit)
          queryParams.push(`limit=${encodeURIComponent(params.limit)}`);
  
        // Append query parameters to URL if they exist
        if (queryParams.length > 0) {
          url += `?${queryParams.join("&")}`;
        }
  
        await apiGet(url)
          .then((response) => {
            callBack && callBack(response, response?.data);
          })
          .catch((err) => {
            console.log("get product api err:", err);
            throw err;
          });
      } catch (err) {
        console.log("get product api err:", err);
        throw err;
      }
    };
  };

  
  export const addProductMetalPurityDetailsAPI = (data, callBack) => {
    return async () => {
      try {
        await apiPost(ApiConstants.productMetalPurityUrl, data)
          .then((response) => {
            callBack && callBack(response?.data);
          })
          .catch((err) => {
            console.log("add product metal purity api err===-=>>>:", err);
            throw err;
          });
      } catch (err) {
        console.log("add product metal purity api err:", err);
        throw err;
      }
    };
  };

  export const updateProductMetalPurityDetailsAPI = (data, callBack) => {
    return async () => {
      try {
        await apiPut(ApiConstants.productMetalPurityUrl, data)
          .then((response) => {
            callBack && callBack(response?.data, response?.data);
          })
          .catch((err) => {
            console.log("update product metal purity api err===-=>>>:", err);
            throw err;
          });
      } catch (err) {
        console.log("update product metal purity api err:", err);
        throw err;
      }
    };
  };


  export const deleteProductMetalPurityDetailsAPI = (productMetalPurityId, callBack) => {
    return async () => {
      try {
        await apiDelete(`${ApiConstants.productMetalPurityUrl}?product_metal_purity_id=${productMetalPurityId}`)
          .then((response) => {
            callBack && callBack(response?.data, response?.data);
          })
          .catch((err) => {
            console.log("delete product metal purity api err===-=>>>:", err);
            throw err;
          });
      } catch (err) {
        console.log("delete product metal purity api err:", err);
        throw err;
      }
    };
  };